import React from 'react';
import Image from 'next/legacy/image';
import { Dialog, styled } from '@mui/material';

import CustomLink from 'components/CustomLink';
import iconClose from '../../public/images/close.svg';

const StyledSmsDialog = styled(Dialog)(() => ({
  '.MuiDialog-container': {
    '.MuiPaper-root': {
      maxWidth: '500px',
      maxHeight: 'none',
      margin: '0',
      borderRadius: '0',
    },
  },
  '@media (max-width:767px)': {
    '.MuiDialog-container': {
      '.MuiPaper-root': {
        width: '100%',
      },
    },
  },
}));

type Props = {
  open: boolean;
  onYes: () => void;
  onDismiss: () => void;
};

// "ONE MORE THING" — final optional SMS opt-in shown after an inquiry is already
// submitted. Continue / X = no consent change; Yes = grant consent. This popup
// only fires callbacks; the parent form sequences the consent mutation and the
// success UI so the inquiry is never blocked.
const SmsConsentPopup: React.FC<Props> = ({ open, onYes, onDismiss }) => (
  <StyledSmsDialog open={open} onClose={onDismiss} disableRestoreFocus>
    <div className="p-10 bg-white border border-gray w-full md:w-[500px]">
      <div className="flex flex-row items-start justify-end mb-2">
        <button
          type="button"
          className="z-50 outline-none"
          onClick={onDismiss}
          aria-label="close popup"
        >
          <Image src={iconClose} alt="close popup" width={15} height={15} />
        </button>
      </div>
      <div className="text-30-47-1 uppercase font-sohneBreitBuch text-center">
        One more thing
      </div>
      <div className="mt-4 text-16-26-0.3 text-center">
        Your request is on its way. Is it ok if you hear from us by text?
      </div>
      <div className="mt-6 p-4 border border-gray bg-beige text-13-20-0.3 text-justify">
        By clicking &quot;Yes&quot;, I consent to receive text messages related
        to real estate services from Condo Black Book LLC. You can reply
        &quot;STOP&quot; at any time to opt-out. Message and data rates may
        apply. Message frequency may vary, text HELP to (305) 697-7667 for
        assistance. For more information, please refer to our{' '}
        <CustomLink
          target="_blank"
          href="/privacy-policy/"
          className="text-underline text-gold-darker"
        >
          Privacy Policy
        </CustomLink>{' '}
        and{' '}
        <CustomLink
          target="_blank"
          href="/terms-of-use/"
          className="text-underline text-gold-darker"
        >
          SMS Terms and Conditions
        </CustomLink>{' '}
        on our website.
      </div>
      <div className="flex justify-between mt-8 text-12-18-0.3 md:text-16-26-0.3">
        <button
          type="button"
          onClick={onDismiss}
          className="w-32 h-10 uppercase bg-white border border-gold hover:bg-gold hover:border-gold"
        >
          Continue
        </button>
        <button
          type="button"
          onClick={onYes}
          className="w-32 h-10 uppercase bg-gold border border-gold hover:bg-gold-hover hover:border-gold-hover"
        >
          Yes
        </button>
      </div>
    </div>
  </StyledSmsDialog>
);

export default SmsConsentPopup;
